import React from "react";
import {
  Box,
  HStack,
  IconButton,
  Image,
  Spacer,
  Tooltip,
  useColorMode,
  useColorModeValue,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  Button,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import {
  FiSettings,
  FiMessageSquare,
  FiLogOut,
  FiDollarSign,
  FiUser,
  FiChevronDown,
  FiGrid,
} from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "../../stores/authStore";
import { UserMenu } from "./UserMenu";

export const PrivateNavbar: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuthStore();
  const { t } = useTranslation();
  const { colorMode } = useColorMode();
  const borderColor = useColorModeValue("gray.200", "gray.700");

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <Box p={2} borderBottom="1px" borderColor={borderColor}>
      <HStack spacing={4}>
        <HStack spacing={2}>
          <Image
            src={`/assets/img/logo-circle-${
              colorMode === "dark" ? "dark" : "light"
            }.svg`}
            alt="Araria"
            height="32px"
            width="32px"
            cursor="pointer"
            onClick={() => navigate("/")}
          />
        </HStack>
        <Spacer />
        <Tooltip label="App" placement="bottom" hasArrow>
          <IconButton
            aria-label="App"
            icon={<FiGrid />}
            onClick={() => navigate("/dashboard")}
            variant="ghost"
          />
        </Tooltip>
        <UserMenu />
      </HStack>
    </Box>
  );
};
